module.exports = __webpack_public_path__ + "LS.png?d0cccca24f46911955fa63476baca28d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/LS.png
// module id = 377
// module chunks = 0